'use strict';

app.directive('rmLessonsCarousel', function ($window, $swipe, $timeout, $animate, $animateCss) {
  return {
    scope: {
      current: '=rmLessonsCarousel'
    },
    require: 'rmLessonsCarousel',
    controller: function () {},
    link: function (scope, element, attrs, carousel) {

      var width;
      var items = [];
      var getWindowWidth = function () {
        width = $window.document.documentElement.offsetWidth - 30;
      };
      var setElementWidth = function (elem) {
        elem.css({ width: width });
      };
      getWindowWidth();
      var resize = function () {
        getWindowWidth();
        items.forEach(setElementWidth);
        move();
      };
      var $$window = angular.element($window);
      $$window.on('resize', resize);
      scope.$on('$destroy', function () {
        $$window.off('resize', resize);
      });
      carousel.item = function (elem) {
        items.push(elem);
        setElementWidth(elem);
      };

      var startCoords, startTime, canceled;
      var shift = function (delta) {
        return scope.current * width * (-1) + (delta || 0);
      };
      var move = function (delta) {
        element.css({ left: shift(delta) + 'px' });
      };
      var animate = function () {
        $animateCss(element, {
          to: { left: shift() + 'px' },
          duration: 0.2,
          easing: 'ease'
        }).start().done($timeout);
      };

      $swipe.bind(element.parent(), {
        start: function (coords) {
          startCoords = coords;
          startTime = Date.now();
          canceled = false;
        },
        cancel: function () {
          canceled = true;
        },
        move: function (coords) {
          move(coords.x - startCoords.x);
        },
        end: function (coords) {
          if (canceled) { return; }
          var delta = Math.abs(coords.x - startCoords.x);
          var time = Date.now() - startTime;
          var dir = coords.x > startCoords.x > 0 ? -1 : 1;
          if (delta > 130 || (delta > 40 && time < 200)) {
            scope.current = Math.max(0, Math.min(scope.current + dir, items.length - 1));
          }
          animate();
        }
      });

      move();
    }
  };
});

app.directive('rmLessonsCarouselItem', function () {
  return {
    require: '^rmLessonsCarousel',
    link: function (scope, element, attrs, carousel) {
      carousel.item(element);
    }
  };
});
